import * as React from 'react';

export default class SiteListEmptyView extends React.Component<{}, {}> {
	render() {
		return (
			<div className={"c-empty-view"}>
				<div className={"description"}>You don't have any sites yet.</div>
			</div>
		);
	}
}
